module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"payTitulos":["Payment acceptance solutions for your business.","The limit is up to you."],"paybtnTxt":"MORE INFORMATION"},"es":{"payTitulos":["Soluciones de aceptación de pago para tu negocio.","El límite lo pones tú."],"paybtnTxt":"MÁS INFORMACIÓN"}}')
  delete Component.options._Ctor
}
